import { Component, OnDestroy, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { NotificationService } from '../../services/notification.service';
import { AppFilter, Notification } from '@app/shared';
import {
  debounceTime,
  takeUntil,
  distinctUntilChanged,
  tap,
  map,
} from 'rxjs/operators';
import {
  TransitionController,
  Transition,
  TransitionDirection,
} from '@richardlt/ng2-semantic-ui';
import { FormControl } from '@angular/forms';
import { Location } from '@angular/common';

@Component({
  selector: 'app-notifications',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
})
export class NotificationsContainer implements OnDestroy {
  @Input() pending;
  private unsubscribe$: Subject<void> = new Subject<void>();

  // transition controllers (router transition coming soon)
  public detailTransitionCtrl = new TransitionController();
  public createTransitionCtrl = new TransitionController();
  public listTransitionCtrl = new TransitionController();

  // this variables controls the visbilities of list and create option component (check template)
  public isCreate: boolean = false;
  public selected: boolean = true;

  public createLoading: boolean = false;
  public createSuccess: boolean = false;
  public createError: string = null;
  public optionPopulated: boolean;
  public notifications: Notification[] = [];
  public notification: Notification;
  public contactUs: boolean;
  public detailUsed: boolean;
  contactDetails: any;
  loadingScroll: boolean;
  public maxSize = 5;

  public unRead: Notification[];
  public read: Notification[];

  //loading icon on clicking register.
  register() {
    this.loadingScroll = true;
  }

  searchParams: AppFilter;
  optionParams: AppFilter;
  filterType: AppFilter;
  loading: boolean;

  //our search control
  public search = new FormControl();
  config = {
    total: 1,
    page: 1,
    records: 1,
  };

  total: number = 1;
  page: number = 1;
  records: number = 1;
  searchFilter: string = '';
  organizationId: string;
  appUserId;
  background: string;
  read_status: boolean;

  //initial option type
  barredSearch: any = {
    read_status: true,
  };

  error: string | null;
  constructor(
    private _searchsvc: NotificationService,
    private location: Location
  ) {
    // initialize  search filter
    this.searchParams = new AppFilter({ sidx: 'dateCreated', rows: 5 });
    this.searchParams.filters = JSON.stringify(this.searchFilter);

    this.optionParams = new AppFilter({ sidx: 'read_status', rows: 5 });
    this.optionParams.filters = JSON.stringify(this.searchFilter);

    this.loadingScroll = false;
    if (window.localStorage.getItem('user')) {
      let authAppUser = JSON.parse(localStorage.getItem('user'));

      this.appUserId = authAppUser.appUserId;
    }

    this.getPage(1);
  }
  searchRecords(search) {
    this.searchFilter = search;
    this.searchParams.filters = JSON.stringify(this.searchFilter);
    this.getPage(1);
  }
  // get page request options with filter params
  getPage(page) {
    console.log('get');
    this.searchParams.page = page;
    this.pending = true;
    this._searchsvc
      .getNotifications({
        appUserId: this.appUserId,
        params: this.searchParams,
      })
      .pipe(
        tap((res) => {
          this.total = +res['records'];
          this.page = page;
          this.records = +this.searchParams.rows;
        }),
        map((res) => res['rows']),
        takeUntil(this.unsubscribe$)
      )
      .subscribe(
        (res: Notification[]) => {
          this.pending = false;
          this.notifications = res;
          this.notifications.map((item) => {
            let s = item.body.split(' ');
            item.data = s.splice(0, 5).join(' ');
          });
          // return;
          // this._searchsvc.setRefreshNotification('');
          this.checkOptionList(this.notifications);
          this.checkRead(this.notifications);
          this.checkUnRead(this.notifications);
        },
        (error) => {
          this.loading = false;
          this.error = error;
        }
      );
  }

  cancel() {
    this.location.back();
  }

  checkRead(value: Notification[]) {
    this.read = [];
    for (var i = 0; i < value.length; i++) {
      if (value[i].read === true) {
        this.read.push(value[i]);
      }
    }
  }

  checkUnRead(value: Notification[]) {
    this.unRead = [];
    for (var i = 0; i < value.length; i++) {
      if (value[i].read === false) {
        this.unRead.push(value[i]);
      }
    }
  }

  MarkasRead(event: Notification) {
    if (event != '') {
      this.read_status = true;
      this.ConfirmMark(event);
      return;
    }
  }

  MarkAllAsRead(event: Notification[]) {
    let unread = this.unRead;
    for (var i = 0; i < unread.length; i++) {
      this.read_status = true;
      this.ConfirmMark(unread[i]);
    }
    return;
  }

  ConfirmMark(event: Notification) {
    this.pending = true;
    this.error = null;
    this._searchsvc
      .markNotifications({
        appUserId: this.appUserId,
        read_status: this.read_status,
        ids: [event.notificationId],
      })
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res) => {
          this.pending = false;
          this.createSuccess = true;
          this.getPage(1);
        },
        (error) => {
          this.pending = false;
          this.createSuccess = false;
          this.error = error;
        }
      );
  }

  checkOptionList(value: Notification[]) {
    if (value != null && value.length > 0) {
      this.optionPopulated = true;
    } else {
      this.optionPopulated = false;
    }
  }

  backOptions(value) {
    if (value === 'create') {
    } else if (value === 'detail') {
    } else {
      this.detailUsed = false;
      this.contactUs = false;
    }
  }

  nextPage(value) {
    this.searchParams.page = value;
    this.paginationPage(this.searchParams);
  }

  onDisplayRecords(value) {
    this.searchParams.rows = value;
    this.paginationPage(this.searchParams);
  }

  // method handling search from option list components
  paginationPage(filter) {
    this.getPage(filter.page);
  }
  sortRecords(search) {
    this.searchParams.sord = search;
    this.getPage(1);
  }
  ngOnDestroy() {
    // unsubscribe all subsciptons
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
